import Divider from '.././Divider';
import * as UI from './styles';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';


function BlockedContent() {

  return (
    <UI.Container>
      <UI.ListHeader>
        <span>
          Conteúdo com Acesso Bloqueado
        </span>
      </UI.ListHeader>
      <Divider w="100%" h={0} />
      <UI.ContentWrapper>
        <p>
        Este conteúdo é de acesso permitido apenas aos assinantes do curso.
        </p>
        <p>
        Para mais informações, entre em contato através das nossas redes: Whatsapp e Instagram
        </p>
      </UI.ContentWrapper>
      <UI.ButtonBox>
        <UI.Redirect as='a' href='https://api.whatsapp.com/send?phone=5581988432370' target='_blank'>
          <div className="btn btn-white btn-animate">
           <FaWhatsapp/> WhatsApp
          </div>
        </UI.Redirect>
        <UI.Redirect as='a' href='https://www.instagram.com/profbrunomachado/' target='_blank'>
          <div className="btn btn-white btn-animate">
           <FaInstagram/> Instagram
          </div>
        </UI.Redirect>
      </UI.ButtonBox>
    </UI.Container>
  );
}

export default BlockedContent;
